import React from 'react';

type Props = {
	quote: string;
	name: string;
	title: string;
	division: string;
};

const Quote = ({ quote, name, title, division }: Props) => (
	<div id="quote">
		<div>
			<div className={division}></div>
			<div>
				<div className="quote-copy">
					<h3>“</h3>
					<h6>{quote}</h6>
					<p>{name}</p>
					<p className="caption-one">{title}</p>
				</div>
			</div>
		</div>
	</div>
);

export default Quote;
